import React from 'react';
import PropTypes from 'prop-types';

const Vault = ({ fill, theme, ...props }) => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1261 8.8715C13.3637 8.46947 13.4999 8.00066 13.4999 7.4999C13.4999 6.99914 13.3637 6.53033 13.1261 6.1283L14.2022 5.0522C14.4658 4.7886 14.4658 4.3612 14.2022 4.0976C13.9386 3.834 13.5113 3.834 13.2477 4.0976L12.1715 5.17372C11.7695 4.93621 11.3007 4.7999 10.7999 4.7999C10.2992 4.7999 9.83037 4.93621 9.42834 5.17372L8.35221 4.0976C8.0886 3.834 7.66128 3.834 7.39767 4.0976C7.13404 4.3612 7.13404 4.7886 7.39767 5.0522L8.4738 6.1283C8.2362 6.53033 8.09994 6.99914 8.09994 7.4999C8.09994 8.00066 8.2362 8.46947 8.4738 8.8715L7.39767 9.94763C7.13404 10.2112 7.13404 10.6386 7.39767 10.9022C7.66128 11.1658 8.0886 11.1658 8.35221 10.9022L9.42834 9.82604C9.83037 10.0636 10.2992 10.1999 10.7999 10.1999C11.3007 10.1999 11.7695 10.0636 12.1715 9.82604L13.2477 10.9022C13.5113 11.1658 13.9386 11.1658 14.2022 10.9022C14.4658 10.6386 14.4658 10.2112 14.2022 9.94763L13.1261 8.8715ZM10.7999 8.8499C10.0544 8.8499 9.44994 8.24546 9.44994 7.4999C9.44994 6.75434 10.0544 6.1499 10.7999 6.1499C11.5455 6.1499 12.1499 6.75434 12.1499 7.4999C12.1499 8.24546 11.5455 8.8499 10.7999 8.8499Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M4.04995 3.675C4.04995 3.30221 3.74774 3 3.37495 3C3.00216 3 2.69995 3.30221 2.69995 3.675V11.325C2.69995 11.6978 3.00216 12 3.37495 12C3.74774 12 4.04995 11.6978 4.04995 11.325V3.675Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M0 3.6748C0 1.81084 1.51104 0.299805 3.375 0.299805H14.625C16.489 0.299805 18 1.81084 18 3.6748V11.3248C18 13.1888 16.489 14.6998 14.625 14.6998H3.375C1.51104 14.6998 0 13.1888 0 11.3248V3.6748ZM3.375 1.6498C2.25662 1.6498 1.35 2.55643 1.35 3.6748V11.3248C1.35 12.4431 2.25662 13.3498 3.375 13.3498H14.625C15.7433 13.3498 16.65 12.4431 16.65 11.3248V3.6748C16.65 2.55643 15.7433 1.6498 14.625 1.6498H3.375Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Vault.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Vault;
